import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { CLIENTES } from './types';
import { RootState } from "@/store/modules/general/types";
import { state } from './state';

const namespaced = true;

type ClientesModule = Module<CLIENTES, RootState>;

export const SeleccionCliente: ClientesModule = {
    namespaced,
    state,
    actions,
    getters,
    mutations,
}